import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VideoRecorder } from '../components/VideoRecorder';
import { ArrowLeftIcon } from 'lucide-react';
export function CreatePrompt() {
  const navigate = useNavigate();
  const [showRecorder, setShowRecorder] = useState(false);
  const [videoBlob, setVideoBlob] = useState<Blob | null>(null);
  const handleSave = () => {
    if (videoBlob) {
      // Save to localStorage for demo purposes
      const prompts = JSON.parse(localStorage.getItem('prompts') || '[]');
      const newPrompt = {
        id: Date.now().toString(),
        title: `Video ${new Date().toLocaleDateString('pl-PL')}`,
        videoUrl: URL.createObjectURL(videoBlob),
        createdAt: new Date().toISOString(),
        responses: []
      };
      prompts.push(newPrompt);
      localStorage.setItem('prompts', JSON.stringify(prompts));
      navigate('/dashboard');
    }
  };
  return <div className="min-h-screen p-6 text-white" data-id="element-32">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-33">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-id="element-34">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-35" />
          Back
        </button>
        <div className="space-y-4" data-id="element-36">
          <h1 className="text-4xl font-bold" data-id="element-37">Nagraj video</h1>
          <p className="text-lg opacity-90" data-id="element-38">Nagraj pytanie lub pomysł</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 space-y-6" data-id="element-39">
          {!showRecorder && !videoBlob && <button onClick={() => setShowRecorder(true)} className="w-full bg-white text-rose-500 px-6 py-4 rounded-xl text-lg font-semibold hover:bg-opacity-90 transition-all" data-id="element-40">
              Start Recording
            </button>}
          {showRecorder && <VideoRecorder onSave={blob => {
          setVideoBlob(blob);
          setShowRecorder(false);
        }} onCancel={() => setShowRecorder(false)} data-id="element-41" />}
          {videoBlob && !showRecorder && <div className="space-y-4" data-id="element-42">
              <div className="aspect-video bg-black rounded-lg overflow-hidden" data-id="element-43">
                <video src={URL.createObjectURL(videoBlob)} controls className="w-full h-full" data-id="element-44" />
              </div>
              <div className="flex gap-4" data-id="element-45">
                <button onClick={() => setVideoBlob(null)} className="flex-1 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl font-semibold hover:bg-white/30 transition-all" data-id="element-46">
                  Re-record
                </button>
                <button onClick={handleSave} className="flex-1 bg-white text-rose-500 px-6 py-3 rounded-xl font-semibold hover:bg-opacity-90 transition-all" data-id="element-47">
                  Save Prompt
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}